




























































import {
  defineComponent,
  ref
} from '@nuxtjs/composition-api';
import { SfModal, SfBar, SfInput, SfButton, SfLoader } from '@storefront-ui/vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import { useForgotPassword } from '@wemade-vsf/customer';

extend('email', {
  ...email,
  message: 'Invalid email',
});

extend('required', {
  ...required,
  message: 'This field is required',
});

export default defineComponent({
  name: 'ForgotPasswordModal',
  components: {
    SfModal,
    SfBar,
    SfInput,
    SfButton,
    SfLoader,
    ValidationObserver,
    ValidationProvider
  },
  setup () {
    const email = ref('');
    const isThankyou = ref(false);
    const { request, error, loading } = useForgotPassword();

    const onFormSubmit = async () => {
      await request({ email: email.value })
      isThankyou.value = true;   
    }

    return {
      email,
      loading,
      onFormSubmit,
      isThankyou
    }
  }
})
